// extracted by mini-css-extract-plugin
export default {"pagination":"Paginate_pagination__NZLD8","active":"Paginate_active__CfOZ+"};